export default class SessionDataManager {

  _callback = null;

  /**
   * Retrieves a key from session storage
   * @param {string} key
   * @returns {any}
   */
  static getStorageItem = (key) => {
    if (!key || !window.sessionStorage) return null;
    return window.sessionStorage.getItem(key);
  }

  /**
   * Stores a value in session storage
   * @param {string} key
   * @param {any} value
   * @returns {any}
   */
  static setStorageItem = (key, value) => {
    if (!key || !window.sessionStorage) return null;
    return window.sessionStorage.setItem(key, value);
  }

  /**
   * Removes a value from session storage
   * @param {string} key
   * @returns {any}
   */
  static removeStorageItem = (key) => {
    if (!key || !window.sessionStorage) return null;
    return window.sessionStorage.removeItem(key);
  }



  // Legacy, used in search results
  static getStorage(callback) {
    this._callback = callback;
    return {
      currentHotel: JSON.parse(sessionStorage.getItem('currentHotel')),
      basket: JSON.parse(sessionStorage.getItem('basket')),
    }
  }

  static setStorage(data, afterQuote) {
    if (afterQuote) {
      sessionStorage.setItem('basket', JSON.stringify(data));
    } else {
      sessionStorage.setItem('currentHotel', JSON.stringify(data));
    }
    if (this._callback) this._callback();
  }
}
